import type { ReactNode } from "react";
import { toast } from "sonner";

/** Drop-in for antd's `message` (static or `App.useApp().message`), backed by sonner. Needs a mounted
 * `<Toaster />` (./toaster.tsx) — `screens/screen.tsx` renders one. */
export const message = {
  success: (content: ReactNode) => toast.success(content),
  error: (content: ReactNode) => toast.error(content),
  info: (content: ReactNode) => toast.info(content),
  warning: (content: ReactNode) => toast.warning(content),
  loading: (content: ReactNode) => toast.loading(content),
};

export interface NotificationArgs {
  message: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
}

/** Drop-in for antd's `notification.open` — a sonner toast with a title and description. */
export const notification = {
  open: ({ message: title, description, icon }: NotificationArgs) => toast(title, { description, icon }),
};
